<template>
    <div class="backdrop" style="z-index:999999" @click.self="onCancel">
        <div class="latpay-settings">
            <div style="display:flex;justify-content:center">
                <span>LayPay Station Settings {{ isDirty ? '*' : '' }}</span>
            </div>
            <div style="margin-bottom:10px"><hr /></div>
            <div style="display:flex;justify-content:space-between; flex-direction: column;height:100%">
                <div style="height: 50px;height: 80%;">
                    <div class="station-input-container">
                        <span>Device Id</span>
                        <input @change="markDirty" class="station-input-item" type="text"  v-model="settings.deviceId"/>
                    </div>

                    <div class="station-input-container">
                        <span>Terminal Secret</span>
                        <input @change="markDirty" class="station-input-item" type="text"  v-model="settings.terminalSecret"/>
                    </div>

                    <div class="station-input-container">
                        <span>Terminal Reference</span>
                        <input @change="markDirty" class="station-input-item" type="text"  v-model="settings.terminalReference"/>
                    </div>

                    <div class="station-input-container">
                        <span>Response Secret</span>
                        <input @change="markDirty" class="station-input-item" type="text"  v-model="settings.responseSecret"/>
                    </div>
                </div>
                <div class="latpay-settings-button-bar" v-if="!processing">
                    <button class="latpay-settings-button" @click="onSave">
                        Save
                    </button>
                    <button class="latpay-settings-button" @click="onCancel">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiStation from "@/api/apiStation";
import LatPayStationSettingsModel from "@/common/models/LatPayStationSettingsModel";
import { getCurrentInstance, ref } from "@vue/runtime-core";

export default {
    setup(props, { emit }) {

        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(true);
        const settings = ref(new LatPayStationSettingsModel())
        const isDirty = ref(false)


        const showDialog = async (pStationId) => {    
            isDirty.value = false;        
            try {
                emitter.emit("server-call-start", "Loading...");
                fetchingData.value = true;
                settings.value = await apiStation.getLatPay(pStationId);                
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;

            // setTimeout(function() {
            //     btnYes.value.focus();
            // }, 50);
        }

        const onCancel = async () => {
            if (isDirty.value) {
                const answer = window.confirm("Do you really want to leave? You have unsaved changes!");
                if (!answer) return;
            }

            emit("on-close");
        };

        const onSave = async () => {
            try {
                emitter.emit("server-call-start", "Saving...");
                fetchingData.value = true;
                await apiStation.saveLatPay(settings.value);
                isDirty.value = false;
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error saving data", err]);
            }
            emitter.emit("server-call-stop");
            emit("on-close");
        };

        const markDirty = () => {            
            isDirty.value = true;
        };

        return {
            showDialog,
            onCancel,
            onSave,
            settings,
            isDirty,
            markDirty
        };
    }
};
</script>

<style>
.latpay-settings {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 35%;
    left: 50%;
    margin-top: -105px;
    margin-left: -255px;
    width: 350px;
    height: 250px;
    background: var(--main-background);
    border-radius: 10px;
    padding: 10px;
    border: 1px solid var(--card-body-border);
}

.latpay-settings-button-bar {
    display: flex;
    justify-content: flex-end;
    padding: 5px;
    margin: 0px;
}

.latpay-settings-button {
    /* background-color: cornflowerblue; */
    color: var(--button-color);
    padding: 10px;
    margin-right: 10px;
    width: 75px;
    cursor: pointer;
}
</style>
